function retrieveTiming(name) {
    const storedTiming = sessionStorage.getItem(name);
    if (!storedTiming) {
        return undefined;
    }
    return JSON.parse(storedTiming);
}
function storeTimingWithTimestamp(name, timing) {
    sessionStorage.setItem(name, JSON.stringify(timing));
}
export function retrieveTimings(names) {
    const timings = new Map();
    names.forEach((name) => {
        const storedTiming = retrieveTiming(name);
        if (storedTiming) {
            timings.set(name, storedTiming);
        }
    });
    return timings;
}
export function storeTiming(name, timing) {
    storeTimingWithTimestamp(name, { ...timing, timestamp: performance.timeOrigin + performance.now() });
}
export function timingTimestamp(name) {
    const storedTiming = retrieveTiming(name);
    if (!storedTiming) {
        return -1;
    }
    return storedTiming.timestamp;
}
